import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import PageAdminOverview from 'pages/PageAdmin/PageAdminOverview'

export const Route = createFileRoute('/_auth/_global/page-admin/')({
  beforeLoad: requireGlobalRole(GlobalRoleType.GLOBAL_ADMIN),
  component: PageAdminOverview,
})
